import { object, string } from 'prop-types';

const CategoryServerPropTypes = {
    category: object
};

const CategoryClientPropTypes = {
    category: object,
    id: string
};

export {
    CategoryServerPropTypes,
    CategoryClientPropTypes
};
